module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cd-Db-Ef.7240e2f1.png";